// User profile (full name + email), stored server-side via the BFF (/api/user/*).
export interface UserProfile {
  fullName: string
  email: string
  updatedAt: string
}

export const profileApi = {
  async get(): Promise<UserProfile | null> {
    const res = await fetch('/api/user/profile', { headers: { Accept: 'application/json' } })
    if (res.status === 404 || res.status === 401) return null
    if (!res.ok) throw new Error(`GET /api/user/profile → ${res.status}`)
    return (await res.json()) as UserProfile
  },
  async save(fullName: string, email: string): Promise<UserProfile> {
    const res = await fetch('/api/user/profile', {
      method: 'PUT',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ fullName, email }),
    })
    if (res.status === 400) throw new Error('Udfyld navn og en gyldig e-mail.')
    if (!res.ok) throw new Error(`PUT /api/user/profile → ${res.status}`)
    return (await res.json()) as UserProfile
  },
}
